import { Link } from "react-router-dom";
import { categories } from "@/mocks/home";

export default function CategoryGrid() {
  return (
    <section id="categories" className="w-full bg-background-50 scroll-mt-20">
      <div className="max-w-content mx-auto w-full px-4 md:px-8 py-14 md:py-20">
        <div className="mb-8 md:mb-10">
          <span className="text-xs md:text-sm font-medium text-primary-600 tracking-wide">
            BROWSE / 主题分类
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            按板块找到你关心的事
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((c) => (
            <Link
              key={c.name}
              to={`/collections?category=${encodeURIComponent(c.name)}`}
              className="group flex flex-col p-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-background-200/60 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-500 text-background-50 group-hover:bg-primary-500 transition-colors">
                  <i className={`${c.icon} text-xl`}></i>
                </span>
                <span className="text-xs text-foreground-500 bg-background-50 px-2 py-1 rounded-md border border-background-200">
                  {c.count} 个合集
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}